import { Fields, Form2 } from "@cd2/forms"
import React from "react"
import { currencyOptions, getCurrencyOption } from "../../utils/currency"

export function CurrencySelect({
  onChange,
  value,
  isClearable,
  disabled,
  label,
  required,
  error,
}: {
  onChange: (
    value?: (typeof currencyOptions)[number]["value"],
    option?: (typeof currencyOptions)[number],
  ) => void
  value?: string
  isClearable?: boolean
  disabled?: boolean
  label?: React.ReactNode
  required?: boolean
  error?: string
}) {
  const selectedOption = getCurrencyOption(value)

  return (
    <Fields.Select2
      label={label}
      showRequiredStar={required}
      onChange={option => onChange(option?.value, option)}
      options={currencyOptions}
      value={selectedOption}
      getOptionLabel={opt => opt.label}
      getOptionValue={opt => opt.value}
      isClearable={isClearable}
      disabled={disabled}
      error={error}
    />
  )
}

export function Form2CurrencySelect({
  field,
  label,
  validations,
  disabled,
  isClearable,
}: {
  field: string
  isClearable?: boolean
  disabled?: boolean
  label?: React.ReactNode
  validations?: { presence?: boolean }
}) {
  Form2.useFormSubmitLock(state => {
    const formField = state.getField(field)
    const value = formField.getValue()
    if (validations?.presence) {
      if (!value) {
        formField.setError("must be present")
        return false
      }
      formField.setError(undefined)
    }
  })
  return (
    <Form2.WithField<string>
      field={field}
      subscribe={true}
      render={formField => (
        <CurrencySelect
          onChange={value => formField.setValue(value)}
          value={formField.getValue()}
          required={validations?.presence}
          label={label}
          disabled={disabled}
          isClearable={isClearable}
          error={formField.getError()}
        />
      )}
    />
  )
}
